import { render, staticRenderFns } from "./EditarCodigo.vue?vue&type=template&id=49c1fca6"
import script from "./EditarCodigo.vue?vue&type=script&lang=js"
export * from "./EditarCodigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports